import React from 'react'

export default function AgentReport(){
    return(
        <h1>Agent Report</h1>
    )
}